import React, { Component } from 'react';
import {Modal,ModalBody,Button} from 'reactstrap';

class ContactModal extends Component {
  state = {  }

  openUrlInNewTab = () => {
    let {website}= this.props.toolDetails;
    if(this.props.toolDetails && website) {
      if(website.startsWith('http://') || website.startsWith('https://') ) {
        window.open(website,'_blank');
      } else {
        let url = 'http://' + website;
        window.open(url,'_blank');
      }
    }
  }

  render() { 
    const {showModal} = this.props;
    const {contactName,contactEmailID,address,contactPhone,website} = this.props.toolDetails;
    return ( 
      <div>
        <Modal 
          isOpen={showModal}>
          <ModalBody style={{padding:'30px 0px'}}>
            <div className="row">
              <div className="offset-md-1 offset-lg-1 pick-office-modal-body-title">
                Contact
              </div>
            </div>
            <div className="">
                <div className="row mt30 mb10">
                  <div className="col-md-3 col-lg-3 text-right enterprise-setting-label">
                  Contact Address:
                  </div>
                  <div className="col-md-9 col-lg-9 enterprise-settings-value">
                    {address ? address : 'N/A'}
                  </div>
                </div>
              <div className="row mb20">
                <div className="col-md-3 col-lg-3 text-right enterprise-setting-label">
                Contact Name:
                </div>
                <div className="col-md-9 col-lg-9 enterprise-settings-value">
                  {contactName ? contactName: 'N/A'}
                </div>
              </div>
              <div className="row mb20">
                <div className="col-md-3 col-lg-3 text-right enterprise-setting-label">
                Contact Email:
                </div>
                <div className="col-md-9 col-lg-9 enterprise-settings-value">
                    {contactEmailID ? <a style={{color:'#5099DE'}} href={`mailto:${contactEmailID}`}>
                    {contactEmailID}
                  </a> : <div className="enterprise-settings-value">N/A</div>}
                </div>
              </div>
              <div className="row mb20">
                <div className="col-md-3 col-lg-3 text-right enterprise-setting-label">
                Contact Phone:
                </div>
                <div className="col-md-9 col-lg-9 enterprise-settings-value">
                  {contactPhone ? contactPhone : 'N/A'}
                </div>
              </div>
              <div className="row mb20">
                <div className="col-md-3 col-lg-3 text-right enterprise-setting-label">
                  Website:
                </div>
                <div className="col-md-9 col-lg-9 enterprise-settings-value" onClick={this.openUrlInNewTab}>
                  {website ? <a href={website} style={{color:'#5099DE', wordBreak: 'break-all'}} target="_blank">{website}</a>
                  : <div className="enterprise-settings-value">N/A</div>} 
                </div>
              </div>
            </div>
              <div className="row mt30">
                <div className="offset-md-1 offset-lg-1 col-md-3 col-lg-3">
                  <Button onClick={this.props.toggle} color="secondary-filled" style={{width:'100%'}}>
                    <span style={{fontSize:'18px',lineHeight:'25px'}}>Done</span>
                  </Button>
                </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
 
export default ContactModal;